module.exports = __webpack_public_path__ + "static/mreavesxlsannaru-020415006EmigreWebOnly-20bdd1a1da6abe71f40eaf0106facd4c.woff";